import FullLogoIcon from './logo/FullLogoIcon';
import AnimatedLogoIcon from './logo/AnimatedLogoIcon';

export { FullLogoIcon, AnimatedLogoIcon };
